import React from "react"
import { StaticQuery, graphql } from "gatsby"

const PageQuery = ({ slug, render: Render }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulLayout {
          edges {
            node {
              slug
              pageTitle
              editableContent {
                json
              }
              banner {
                headlineContent {
                  json
                }
                sublineContent {
                  json
                }
                theme
              }
              contentModules {
                __typename    
                ...on ContentfulSectionImageWithContent {
                  id
                }
                ...on ContentfulSectionExpandingGallery {
                  id
                }
                ...on ContentfulSectionMap {
                  id
                }
                ...on ContentfulSectionContentCollection {
                  id
                }
                ...on ContentfulSectionLocations {
                  id
                }
                ...on ContentfulSectionPress {
                  id
                }
                ...on ContentfulSectionTeam {
                  id
                }
                ...on ContentfulSectionBanner {
                  id
                }
                ...on ContentfulSectionJobOpenings {
                  id
                }
                ...on ContentfulContentForm {
                  id
                }
                ...on ContentfulContentWidget {
                  id
                }
                ...on ContentfulContentText {
                  id
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const page = data.allContentfulLayout.edges.find(({ node }) => (
        node.slug === slug
      ))

      return <Render data={page.node} />
    }}
  />
)

export default PageQuery
